module.exports = __webpack_public_path__ + "img/bubao.92bf3e18.png";